import React, { useState } from 'react';
import logo from "../assets/img/Ai-Horizon-Logo.png";
import { HiMenuAlt4 } from "react-icons/hi";
import { IoCloseSharp } from "react-icons/io5";

import "./Navbar.css";

export default function Navbar() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <div style={{
            backgroundColor: '#000E05',
            display: 'flex',
            alignItems: 'center',
            padding: '20px 60px 20px 60px',
            // position: 'sticky',
            top: 0,
            flexDirection: 'row',
            flexWrap: 'wrap',
            boxSizing: 'border-box',
            width:"100%",
            zIndex: 1000
        }}>
            <img
                src={logo}
                alt="logo"
                style={{ width: '10.5%', marginBottom: '10px', cursor: 'pointer', marginLeft:"7px"  }}
                onClick={() => window.location.href = ("https://ai-horizon.io/")}
                className="navbar-image"
            />

            <div style={{
                color: '#fff',
                display: 'flex',
                flexGrow: 1,
                justifyContent: 'flex-end',
                marginRight: '3%',
                fontFamily: 'Open Sans, sans-serif',
                flexWrap: 'wrap',
                fontSize:"14px",
            }}>
                <nav style={{
                    display: 'flex',
                    cursor: 'pointer',
                    margin: 0,
                    flexWrap: 'wrap',
                    justifyContent: 'flex-end'
                }}>
                    <p onClick={() => window.location.href = ("https://ai-horizon.io/")} className="navbar-links-p">Home</p>
                    <p onClick={() => window.location.href = ("https://ai-horizon.io/about/")} className="navbar-links-p">About Us</p>
                    <p onClick={() => window.location.href = ("https://ai-horizon.io/platform/")} className="navbar-links-p">Platform</p>
                    <p onClick={() => window.location.href = ("https://ai-horizon.io/industries/")} className="navbar-links-p">Industries</p>
                    <p onClick={() => window.location.href = ("https://ai-horizon.io/blogs/")} className="navbar-links-p">Blogs</p>
                    <p onClick={() => window.location.href = ("https://ai-horizon.io/partners-and-affiliate/")} className="navbar-links-p">Partners</p>
                    <p onClick={() => window.location.href = ("https://ai-horizon.io/careers/")} className="navbar-links-p">Careers</p>
                    <p onClick={() => window.location.href = ("https://ai-horizon.io/contact-us/")} className="navbar-links-p">Contact Us</p>
                </nav>

                <div className="navbar-menubutton" onClick={toggleSidebar} >
                    <HiMenuAlt4 />
                </div>
            </div>

            {isSidebarOpen && (
                <div className="sidebar">
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>

                        <div>
                            <img
                                src={logo}
                                alt="logo"
                                style={{ width: '40%', marginBottom: '10px', cursor: 'pointer' }}
                                onClick={() => window.location.href = ("https://ai-horizon.io/")}
                            />
                        </div>
                        <div onClick={toggleSidebar} >
                            <IoCloseSharp style={{marginRight:'30px'}} />
                        </div>
                    </div>
                    <nav className="sidebar-nav">
                        <p onClick={() => window.location.href = ("https://ai-horizon.io/")}>Home</p>
                        <p onClick={() => window.location.href = ("https://ai-horizon.io/about/")}>About Us</p>
                        <p onClick={() => window.location.href = ("https://ai-horizon.io/platform/")}>Platform</p>
                        <p onClick={() => window.location.href = ("https://ai-horizon.io/industries/")}>Industries</p>
                        <p onClick={() => window.location.href = ("https://ai-horizon.io/blogs/")}>Blogs</p>
                        <p onClick={() => window.location.href = ("https://ai-horizon.io/partners-and-affiliate/")}>Partners</p>
                        <p onClick={() => window.location.href = ("https://ai-horizon.io/careers/")}>Careers</p>
                        <p onClick={() => window.location.href = ("https://ai-horizon.io/contact-us/")}>Contact Us</p>
                    </nav>
                </div>
            )}
        </div>
    );
}

